import { PropertyConverter } from 'angular2-jsonapi'
import { VersaoWeb } from '../controle-versao/versao-web'
import { VersaoWebJson } from '../controle-versao/versao-web-json.interface'

export class VersoesWebConverter implements PropertyConverter {
    mask(value: string) {
        const objArray = JSON.parse(value) as VersaoWebJson[]

        return objArray.map(obj => new VersaoWeb(obj))
    }

    unmask(versoesWeb: VersaoWeb[]) {
        if (typeof versoesWeb === 'string') {
            return versoesWeb
        }

        const objArray = versoesWeb.map(v => {
            return {
                Tipo: v.sistema,
                Versao: v.numero
            } as VersaoWebJson
        })

        return JSON.stringify(objArray)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/converters/versoes-web.converter.ts